<template>
    <v-row no-gutters>
        <v-col cols="12" lg="10">
            <v-card variant="outlined" class="mb-4">
                <v-card-text class="overflow-y-auto">
                    <div class="d-flex align-center gc-2 py-1 px-4">
                        <v-spacer />
                        <div v-if="isShowMarkUp || isShowLoyalty || isShowServiceFee" style="width: 200px">
                            {{ label || $t('markup_value') }}
                        </div>
                        <div v-if="isShowCalculationCommission" style="width: 180px">
                            {{ label || $t('commission') }}
                        </div>
                        <template v-if="isShowVat">
                            <div style="width: 100px">{{ $t('sales_settings_tabs.vat') }}%</div>
                            <div style="width: 200px">{{ $t('vat_code') }}</div>
                        </template>
                        <template v-if="!isReadOnly">
                            <div style="width: 40px" />
                            <div v-if="ruleRoot?.pricingRuleEntries?.length" style="width: 40px" />
                        </template>
                    </div>
                    <div class="d-flex align-center gc-2 py-1 px-4">
                        <div class="text-capitalize">{{ $t('all') }}</div>
                        <v-spacer />
                        <template v-if="!ruleRoot?.pricingRuleEntries?.length">
                            <!--TODO[p4] refactoring - delete duplicate code -?-->
                            <template v-if="isShowMarkUp">
                                <NumberInputWithButtons
                                    v-model="ruleRoot.markupValue"
                                    :label="
                                        ruleRoot.markupValueType === 'PERCENTAGE'
                                            ? $t('percent')
                                            : ruleRoot.markupValueType === 'MARGIN'
                                              ? $t('margin')
                                              : $t('amount')
                                    "
                                    :width="200"
                                    :buttons="[
                                        !isHideMarkupMargin && {
                                            icon: 'mdi-margin',
                                            active: ruleRoot.markupValueType === 'MARGIN',
                                            onClick: () => (ruleRoot.markupValueType = 'MARGIN'),
                                        },
                                        {
                                            icon: 'mdi-percent',
                                            active: ruleRoot.markupValueType === 'PERCENTAGE',
                                            onClick: () => (ruleRoot.markupValueType = 'PERCENTAGE'),
                                        },
                                        {
                                            icon: 'mdi-cash',
                                            active: ruleRoot.markupValueType === 'ABSOLUTE',
                                            onClick: () => (ruleRoot.markupValueType = 'ABSOLUTE'),
                                        },
                                    ]"
                                    :disabled="isReadOnly"
                                />
                            </template>
                            <template v-if="isShowCalculationCommission">
                                <NumberInputWithButtons
                                    v-model="ruleRoot.commissionValue"
                                    :label="!ruleRoot.commissionInCurrency ? $t('percent') : $t('amount')"
                                    :width="180"
                                    :buttons="[
                                        {
                                            icon: 'mdi-percent',
                                            active: !ruleRoot.commissionInCurrency,
                                            onClick: () => (ruleRoot.commissionInCurrency = false),
                                        },
                                        {
                                            icon: 'mdi-cash',
                                            active: ruleRoot.commissionInCurrency,
                                            onClick: () => (ruleRoot.commissionInCurrency = true),
                                        },
                                    ]"
                                    :disabled="isReadOnly"
                                />
                            </template>
                            <template v-if="isShowVat">
                                <v-number-input
                                    v-model="ruleRoot.vatValue"
                                    :min="0"
                                    hide-details
                                    class="flex-grow-0 flex-shrink-0"
                                    width="100"
                                    data-cy="vat-value"
                                    :rules="[requiredRule('sales_settings_tabs.vat')]"
                                />
                                <v-text-field
                                    v-model="ruleRoot.vatCode"
                                    hide-details
                                    width="200"
                                    class="flex-grow-0 flex-shrink-0"
                                />
                            </template>
                            <template v-if="isShowLoyalty">
                                <NumberInputWithButtons
                                    v-model="ruleRoot.loyaltyValue"
                                    :label="ruleRoot.loyaltyValueType === 'PERCENTAGE' ? $t('percent') : $t('amount')"
                                    :width="200"
                                    :buttons="[
                                        {
                                            icon: 'mdi-percent',
                                            active: ruleRoot.loyaltyValueType === 'PERCENTAGE',
                                            onClick: () => (ruleRoot.loyaltyValueType = 'PERCENTAGE'),
                                        },
                                        {
                                            icon: 'mdi-cash',
                                            active: ruleRoot.loyaltyValueType === 'ABSOLUTE',
                                            onClick: () => (ruleRoot.loyaltyValueType = 'ABSOLUTE'),
                                        },
                                    ]"
                                    :disabled="isReadOnly"
                                />
                            </template>
                            <template v-if="isShowServiceFee">
                                <NumberInputWithButtons
                                    v-model="ruleRoot.serviceFeeValue"
                                    :label="
                                        ruleRoot.serviceFeeValueType === 'PERCENTAGE' ? $t('percent') : $t('amount')
                                    "
                                    :width="200"
                                    :buttons="[
                                        {
                                            icon: 'mdi-percent',
                                            active: ruleRoot.serviceFeeValueType === 'PERCENTAGE',
                                            onClick: () => (ruleRoot.serviceFeeValueType = 'PERCENTAGE'),
                                        },
                                        {
                                            icon: 'mdi-cash',
                                            active: ruleRoot.serviceFeeValueType === 'ABSOLUTE',
                                            onClick: () => (ruleRoot.serviceFeeValueType = 'ABSOLUTE'),
                                        },
                                    ]"
                                    :disabled="isReadOnly"
                                />
                            </template>
                        </template>
                        <template v-if="!isReadOnly">
                            <div style="width: 40px">
                                <v-btn
                                    size="small"
                                    color="success"
                                    variant="text"
                                    icon="mdi-plus"
                                    :data-cy="`add-for-${ruleRoot.id}`"
                                    @click="openModal(ruleRoot.id, ruleRoot)"
                                />
                            </div>
                            <div v-if="ruleRoot?.pricingRuleEntries?.length" style="width: 40px" />
                        </template>
                    </div>
                    <v-treeview
                        v-if="ruleRoot?.pricingRuleEntries?.length"
                        :items="ruleRoot.pricingRuleEntries"
                        item-children="pricingRuleEntries"
                    >
                        <template v-slot:prepend="{item, isOpen}">
                            <v-icon v-if="item?.pricingRuleEntries?.length">
                                {{ isOpen ? 'mdi-folder-open' : 'mdi-folder' }}
                            </v-icon>
                            <v-icon v-else> mdi-file-document-outline </v-icon>
                        </template>
                        <template v-slot:append="{item}">
                            <template v-if="item?.pricingRuleEntries?.length && !isReadOnly">
                                <div class="pt-2 d-flex gc-2 align-center">
                                    <div style="width: 40px">
                                        <v-btn
                                            size="small"
                                            color="success"
                                            variant="text"
                                            icon="mdi-plus"
                                            :data-cy="`add-for-${item.id}`"
                                            @click="openModal(item.id, item)"
                                        />
                                    </div>
                                    <div style="width: 40px">
                                        <v-btn
                                            size="small"
                                            color="error"
                                            variant="text"
                                            icon="mdi-close"
                                            :data-cy="`remove-${item.id}`"
                                            @click="removeItem(item.id)"
                                        />
                                    </div>
                                </div>
                            </template>
                        </template>
                        <template v-slot:title="{item}">
                            <div class="d-flex gc-2 align-center">
                                <div>{{ item.label }}</div>
                                <v-spacer />
                                <div class="pt-2 d-flex gc-2 align-center">
                                    <template v-if="!item?.pricingRuleEntries?.length">
                                        <template v-if="isShowMarkUp">
                                            <NumberInputWithButtons
                                                v-model="item.markupValue"
                                                :label="
                                                    item.markupValueType === 'PERCENTAGE'
                                                        ? $t('percent')
                                                        : item.markupValueType === 'MARGIN'
                                                          ? $t('margin')
                                                          : $t('amount')
                                                "
                                                :width="200"
                                                :buttons="[
                                                    !isHideMarkupMargin &&
                                                        useIsShowMarkupMargin && {
                                                            icon: 'mdi-margin',
                                                            active: item.markupValueType === 'MARGIN',
                                                            onClick: () => (item.markupValueType = 'MARGIN'),
                                                        },
                                                    {
                                                        icon: 'mdi-percent',
                                                        active: item.markupValueType === 'PERCENTAGE',
                                                        onClick: () => (item.markupValueType = 'PERCENTAGE'),
                                                    },
                                                    {
                                                        icon: 'mdi-cash',
                                                        active: item.markupValueType === 'ABSOLUTE',
                                                        onClick: () => (item.markupValueType = 'ABSOLUTE'),
                                                    },
                                                ]"
                                                :disabled="isReadOnly"
                                            />
                                        </template>
                                        <template v-if="isShowCalculationCommission">
                                            <NumberInputWithButtons
                                                v-model="item.commissionValue"
                                                :label="!item.commissionInCurrency ? $t('percent') : $t('amount')"
                                                :width="180"
                                                :buttons="[
                                                    {
                                                        icon: 'mdi-percent',
                                                        active: !item.commissionInCurrency,
                                                        onClick: () => (item.commissionInCurrency = false),
                                                    },
                                                    {
                                                        icon: 'mdi-cash',
                                                        active: item.commissionInCurrency,
                                                        onClick: () => (item.commissionInCurrency = true),
                                                    },
                                                ]"
                                                :disabled="isReadOnly"
                                            />
                                        </template>
                                        <template v-if="isShowVat">
                                            <v-number-input
                                                v-model="item.vatValue"
                                                :min="0"
                                                hide-details
                                                class="flex-grow-0 flex-shrink-0"
                                                width="100"
                                                :data-cy="`vat-value-${item.id}`"
                                                :rules="[requiredRule('sales_settings_tabs.vat')]"
                                            />
                                            <v-text-field
                                                v-model="item.vatCode"
                                                hide-details
                                                width="200"
                                                :data-cy="`vat-code-${item.id}`"
                                                class="flex-grow-0 flex-shrink-0"
                                            />
                                        </template>
                                        <template v-if="isShowLoyalty">
                                            <NumberInputWithButtons
                                                v-model="item.loyaltyValue"
                                                :label="
                                                    item.loyaltyValueType === 'PERCENTAGE'
                                                        ? $t('percent')
                                                        : $t('amount')
                                                "
                                                :width="200"
                                                :buttons="[
                                                    {
                                                        icon: 'mdi-percent',
                                                        active: item.loyaltyValueType === 'PERCENTAGE',
                                                        onClick: () => (item.loyaltyValueType = 'PERCENTAGE'),
                                                    },
                                                    {
                                                        icon: 'mdi-cash',
                                                        active: item.loyaltyValueType === 'ABSOLUTE',
                                                        onClick: () => (item.loyaltyValueType = 'ABSOLUTE'),
                                                    },
                                                ]"
                                                :disabled="isReadOnly"
                                            />
                                        </template>
                                        <template v-if="isShowServiceFee">
                                            <NumberInputWithButtons
                                                v-model="item.serviceFeeValue"
                                                :label="
                                                    item.serviceFeeValueType === 'PERCENTAGE'
                                                        ? $t('percent')
                                                        : $t('amount')
                                                "
                                                :width="200"
                                                :buttons="[
                                                    {
                                                        icon: 'mdi-percent',
                                                        active: item.serviceFeeValueType === 'PERCENTAGE',
                                                        onClick: () => (item.serviceFeeValueType = 'PERCENTAGE'),
                                                    },
                                                    {
                                                        icon: 'mdi-cash',
                                                        active: item.serviceFeeValueType === 'ABSOLUTE',
                                                        onClick: () => (item.serviceFeeValueType = 'ABSOLUTE'),
                                                    },
                                                ]"
                                                :disabled="isReadOnly"
                                            />
                                        </template>
                                        <template v-if="!isReadOnly">
                                            <div style="width: 40px">
                                                <v-btn
                                                    size="small"
                                                    color="success"
                                                    variant="text"
                                                    icon="mdi-plus"
                                                    :data-cy="`add-for-${item.id}`"
                                                    @click="openModal(item.id, item)"
                                                />
                                            </div>
                                            <div style="width: 40px">
                                                <v-btn
                                                    v-if="item.ruleToken !== 'other'"
                                                    size="small"
                                                    color="error"
                                                    variant="text"
                                                    icon="mdi-close"
                                                    :data-cy="`remove-${item.id}`"
                                                    @click="removeItem(item.id)"
                                                />
                                            </div>
                                        </template>
                                    </template>
                                </div>
                            </div>
                        </template>
                    </v-treeview>
                </v-card-text>
            </v-card>
        </v-col>
    </v-row>
    <TreeViewCalculationModal
        v-model="isShowModal"
        :available-root-rules="useAvailableRootRules"
        :selected-root="selectedRoot"
        :available-suppliers="suppliers"
        :currency="currency"
        @add-item="addItemToTree"
    />
</template>
<script setup lang="ts">
    import {VTreeview} from 'vuetify/labs/VTreeview'
    import TreeViewCalculationModal from '~/components/salesSettings/TreeViewCalculationModal.vue'
    import {nanoid} from 'nanoid'
    import {requiredRule} from '~/composables/rules'

    const props = defineProps<{
        isShowCalculationCommission?: boolean
        isShowMarkUp?: boolean
        isShowVat?: boolean
        isShowLoyalty?: boolean
        isShowServiceFee?: boolean
        isHideMarkupMargin?: boolean
        currency?: string
        label?: string
    }>()

    const isReadOnly = inject('isReadOnly', ref(false))

    const ruleRoot = defineModel<any>()
    const isShowModal = ref<boolean>(false)

    const availableRootRules = ref<string[]>([
        'supplierRule',
        'tariffTagRule',
        'productTypeRule',
        'priceRangeRule',
        'countryRule',
    ])
    const availableRootRulesFullList = ref<string[]>([
        'supplierRule',
        'cityRule',
        'accommodationHotelCategoryRule',
        'tariffTagRule',
        'productTypeRule',
        'priceRangeRule',
        'countryRule',
    ])

    const suppliers = ref([])

    const selectedRootId = ref<boolean>(null)
    const selectedRoot = ref<any>(null)

    const app = useNuxtApp()
    const {t} = useI18n()

    const openModal = (nodeId, node) => {
        isShowModal.value = true
        selectedRootId.value = nodeId
        selectedRoot.value = node
    }

    onMounted(async () => {
        EventBus.$on(UPDATE_CONTRACT, updateContract)
        await loadSuppliers()
        await updateContract()
    })

    onBeforeUnmount(() => {
        EventBus.$off(UPDATE_CONTRACT, updateContract)
    })

    const updateContract = async () => {
        ruleRoot.value = (await makeTree([ruleRoot.value]))[0]
    }

    const makeTree = async (entries, parentFilters = []) => {
        return await Promise.all(
            entries.map(async entry => {
                const entryCopy = {...entry}
                entryCopy.label = await getLabelByRuleToken(entry.ruleToken, entry.ruleValue)

                const currentFilter = {ruleToken: entryCopy.ruleToken, ruleValue: entryCopy.ruleValue}

                const newParentFilters =
                    entryCopy.ruleToken !== 'rootRule' && entryCopy.ruleToken !== 'other'
                        ? [...parentFilters, currentFilter]
                        : entryCopy.ruleToken === 'other'
                          ? [...parentFilters, {ruleToken: entries[0].ruleToken, ruleValue: null}]
                          : [...parentFilters]

                entryCopy.parentFilters = newParentFilters
                entryCopy.label = await getLabelByRuleToken(entry.ruleToken, entry.ruleValue)
                if (!entryCopy?.id) entryCopy.id = nanoid()

                if (!entryCopy.pricingRuleEntries?.length) {
                    delete entryCopy.pricingRuleEntries
                } else {
                    entryCopy.pricingRuleEntries = await makeTree(entryCopy.pricingRuleEntries, newParentFilters)
                }
                return entryCopy
            })
        )
    }

    const removeItem = id => {
        const recursiveRemove = items => {
            return items
                .map(item => ({...item}))
                .filter(item => {
                    if (item.pricingRuleEntries) {
                        item.pricingRuleEntries = recursiveRemove(item.pricingRuleEntries)
                        if (item.pricingRuleEntries.length === 1 && item.pricingRuleEntries[0].otherRule) {
                            const parentFilters = item.pricingRuleEntries[0].parentFilters || []
                            const filteredParentFilters = parentFilters.filter(
                                filter => !item.parentFilters.includes(filter)
                            )

                            const recursiveFiltersUpdate = entries => {
                                return entries.map(childItem => {
                                    const updatedItem = {...childItem}
                                    updatedItem.parentFilters = updatedItem.parentFilters.filter(
                                        filter => !filteredParentFilters.includes(filter)
                                    )
                                    if (updatedItem.pricingRuleEntries?.length) {
                                        updatedItem.pricingRuleEntries = recursiveFiltersUpdate(
                                            updatedItem.pricingRuleEntries
                                        )
                                    }
                                    return updatedItem
                                })
                            }
                            if (item.pricingRuleEntries[0].pricingRuleEntries?.length) {
                                item.pricingRuleEntries[0].pricingRuleEntries = recursiveFiltersUpdate(
                                    item.pricingRuleEntries[0].pricingRuleEntries
                                )
                            }
                            item.pricingRuleEntries = item.pricingRuleEntries[0].pricingRuleEntries
                        }
                    }
                    return item.id !== id
                })
        }

        const updatedEntries = recursiveRemove([ruleRoot.value])

        ruleRoot.value = updatedEntries[0]
    }

    const addItemToTree = async ({selectedItems, ruleToken}) => {
        const parent = selectedRoot.value
        if (!parent) return

        if (!parent.pricingRuleEntries) parent.pricingRuleEntries = []

        const ruleTypesWithMultipleSelection = ['productTypeRule', 'supplierRule', 'accommodationHotelCategoryRule']

        if (ruleTypesWithMultipleSelection.includes(ruleToken)) {
            parent.pricingRuleEntries = filterExistingEntries(parent.pricingRuleEntries, selectedItems)
            parent.pricingRuleEntries = addNewEntries(
                parent.pricingRuleEntries,
                selectedItems,
                ruleToken,
                parent.parentFilters,
                parent
            )
        } else {
            selectedItems.forEach(item => {
                parent.pricingRuleEntries.unshift(createNewEntry(item, ruleToken, parent.parentFilters, parent))
            })
        }
        ensureOtherEntryExists(parent.pricingRuleEntries, parent.pricingRuleEntries?.[0]?.parentFilters, parent)
    }

    const filterExistingEntries = (entries, selectedItems) => {
        return entries.filter(
            entry => entry.ruleToken === 'other' || selectedItems.some(item => item.ruleValue === entry.ruleValue)
        )
    }

    const addNewEntries = (entries, selectedItems, ruleToken, parentFilters, parent) => {
        const newEntries = []
        selectedItems.forEach(item => {
            const existingEntry = entries.find(entry => entry.ruleValue === item.ruleValue)
            if (existingEntry) {
                newEntries.push(existingEntry)
            } else {
                newEntries.push(createNewEntry(item, ruleToken, parentFilters, parent))
            }
        })

        const otherEntry = entries.find(entry => entry.ruleToken === 'other')
        if (otherEntry) {
            newEntries.push(otherEntry)
        }
        return newEntries
    }

    const createNewEntry = (item, ruleToken, parentFilters, parent) => {
        let newEntry = {
            id: nanoid(),
            ruleToken,
            otherRule: false,
            labelToken: `labelToken.${item.ruleValue}`,
            label: item.label,
            ruleValue: item.ruleValue,
            parentFilters: [...parentFilters, {ruleToken, ruleValue: item.ruleValue}],
            ruleOperation: 'EQ',
        }
        return {...newEntry, ...getCommonEntries(parent)}
    }

    const ensureOtherEntryExists = (entries, parentFilters, parent) => {
        if (!entries.some(({ruleToken}) => ruleToken === 'other')) {
            let newEntry = {
                id: nanoid(),
                ruleToken: 'other',
                otherRule: true,
                labelToken: 'labelToken.other',
                label: t('other'),
                ruleValue: 'none',
                parentFilters: [...parentFilters, {ruleToken: 'other', ruleValue: null}],
                ruleOperation: 'EQ',
            }
            newEntry = {...newEntry, ...getCommonEntries(parent)}
            entries.push(newEntry)
        }
    }

    const getCommonEntries = parent => {
        if (props.isShowCalculationCommission || props.isShowMarkUp) {
            return {
                markupValue: parent.markupValue,
                markupValueType: parent.markupValueType,
                commissionInCurrency: parent.commissionInCurrency,
                commissionValue: parent.commissionValue,
            }
        }
        if (props.isShowVat) {
            return {
                vatValue: parent.vatValue,
                vatCode: null,
            }
        }
        if (props.isShowLoyalty) {
            return {
                loyaltyValue: parent.loyaltyValue,
                loyaltyValueType: parent.loyaltyValueType,
            }
        }
        if (props.isShowServiceFee) {
            return {
                serviceFeeValue: parent.serviceFeeValue,
                serviceFeeValueType: parent.serviceFeeValueType,
            }
        }
    }

    const useAvailableRootRules = computed(() => {
        if (selectedRoot.value?.pricingRuleEntries?.length) {
            return [selectedRoot.value.pricingRuleEntries[0].ruleToken]
        }

        if (selectedRoot.value?.parentFilters?.length) {
            const parentRuleTokens = selectedRoot.value.parentFilters.map(filter => filter.ruleToken)

            if (parentRuleTokens.includes('productTypeRule')) {
                const filteredRules = availableRootRulesFullList.value.filter(rule => !parentRuleTokens.includes(rule))
                const isIncludesAccommodation = selectedRoot.value.parentFilters.find(
                    filter => filter.ruleValue === 'accommodation'
                )
                if (isIncludesAccommodation) return filteredRules

                const availableProductsForCitySelection = [
                    'carRent',
                    'cruise',
                    'ownExtraService',
                    'flight',
                    'accommodation',
                    'tour',
                    'transfer',
                ]

                const productValue =
                    selectedRoot.value.ruleToken === 'productTypeRule'
                        ? selectedRoot.value.ruleValue
                        : selectedRoot.value.parentFilters.find(
                              parenFilter => parenFilter.ruleToken === 'productTypeRule'
                          ).ruleValue

                return filteredRules.filter(rule =>
                    availableProductsForCitySelection.includes(productValue)
                        ? rule !== 'accommodationHotelCategoryRule'
                        : rule !== 'accommodationHotelCategoryRule' && rule !== 'cityRule'
                )
            }

            return availableRootRules.value.filter(rule => !parentRuleTokens.includes(rule))
        }

        return availableRootRules.value
    })

    const getLabelByRuleToken = async (ruleToken, ruleValue) => {
        let cleanRuleValue
        switch (ruleToken) {
            case 'supplierRule':
                return suppliers.value.find(({code}) => code === ruleValue)?.name || ruleValue
            case 'productTypeRule':
                return t(`productType.${ruleValue}`)
            case 'priceRangeRule':
                return getPriceRangeTitle(ruleValue)
            case 'countryRule':
                return (
                    runtimeStore.countries.find(country => country.id == ruleValue)?.name ||
                    `${t('country')}: ${ruleValue}`
                )
            case 'cityRule':
                return (await getCityById(ruleValue)) || `${t('city')}: ${ruleValue}`
            case 'accommodationHotelCategoryRule':
                cleanRuleValue = ruleValue.replace('hotelcategory.', '')
                return cleanRuleValue === 'other' ? t('no_category') : `${cleanRuleValue}*`
            case 'other':
            case 'rootRule':
                return t('other')
            default:
                return ruleValue
        }
    }

    const getPriceRangeTitle = label => {
        const range = label.split('-')?.filter(item => item !== '')
        if (range?.length === 1) {
            return `${t('price_range')} (${t(`${range[0]}${props?.currency ? ` ${props.currency}` : ''}`)} ${t('or_more')})`
        }
        return `${t('price_range')} (${t(`${label}${props?.currency ? ` ${props.currency}` : ''}`)})`
    }

    async function loadSuppliers(): Promise<void> {
        suppliers.value = (await app.$api.suppliers.get())?.suppliers.sort((a, b) => a.name.localeCompare(b.name))
    }

    const getCityById = async id => {
        return (await app.$api.locations.get({id})).cities?.[0]?.name
    }

    const useIsShowMarkupMargin = computed(() => {
        return runtimeStore.getCRMOption('asp.option.enable.markup.margin')
    })
</script>
